import { useState, useEffect } from 'react';

const TestimonialCarouselSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const testimonials = [
    {
      id: 1,
      name: '陳先生',
      location: '新北市泰山區',
      service: '家庭搬家',
      date: '2024年3月',
      rating: 5,
      comment: '搬家師傅非常專業，對於家具的防護包裝做得相當精緻且到位，確保物品在運輸過程中不受損。動作迅速且俐落，分工明確，搬運效率很高。態度親切有耐心，讓整個搬家過程很順利！真的很推薦建鈞搬家！',
      image: 'https://public.readdy.ai/ai/img_res/c2cec448368ba89b209dc772092ef81a.jpg',
      highlight: '防護包裝超專業！'
    },
    {
      id: 2,
      name: '林小姐',
      location: '台北市大安區',
      service: '精緻搬家',
      date: '2024年3月',
      rating: 5,
      comment: '報價非常實在且透明，不會隨意加價。搬家前線上估價系統很方便，讓我在預約前就能有清楚的預算參考。搬家當天準時到達，服務品質超乎預期！LINE 諮詢回覆也很快速。',
      image: 'https://readdy.ai/api/search-image?query=Young%20professional%20Asian%20woman%20in%20her%2030s%20in%20a%20bright%20modern%20apartment%20with%20organized%20furniture%2C%20cheerful%20smile%2C%20soft%20natural%20lighting%2C%20contemporary%20interior%20design&width=400&height=500&seq=testimonial102&orientation=portrait',
      highlight: '價格透明又實在！'
    },
    {
      id: 3,
      name: '王太太',
      location: '桃園市中壢區',
      service: '套房搬遷',
      date: '2024年2月',
      rating: 5,
      comment: '沙發和床墊的防護包裝做得特別好，搬運過程非常小心。師傅們很有經驗，對於大型家具的拆裝都很專業。價格合理，服務態度也很好，非常推薦！整個搬家過程讓人很放心。',
      image: 'https://readdy.ai/api/search-image?query=Friendly%20Asian%20woman%20in%20her%2050s%20in%20a%20cozy%20apartment%20setting%20with%20furniture%2C%20warm%20smile%2C%20soft%20natural%20lighting%2C%20comfortable%20home%20interior%20background&width=400&height=500&seq=testimonial103&orientation=portrait',
      highlight: '家具保護超仔細！'
    },
    {
      id: 4,
      name: '張先生',
      location: '新北市板橋區',
      service: '家庭搬家',
      date: '2024年2月',
      rating: 5,
      comment: '第二次找建鈞搬家了！上次搬家的經驗很好，這次又再次選擇他們。師傅們動作快又仔細，對長輩很有耐心，讓人很放心。24小時服務真的很方便，隨時都能預約！',
      image: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Asian%20man%20with%20glasses%20in%20a%20family%20home%20setting%20with%20moving%20boxes%2C%20genuine%20smile%2C%20warm%20ambient%20lighting%2C%20comfortable%20residential%20background&width=400&height=500&seq=testimonial104&orientation=portrait',
      highlight: '回頭客推薦！'
    },
    {
      id: 5,
      name: '李小姐',
      location: '新竹市東區',
      service: '長途搬家',
      date: '2024年3月',
      rating: 5,
      comment: 'LINE 諮詢回覆很快，報價清楚透明。搬家當天師傅們準時到達，效率超高！家具都保護得很好，沒有任何損傷。全省回頭車服務讓長途搬家也很划算！服務範圍很廣，很方便。',
      image: 'https://readdy.ai/api/search-image?query=Young%20professional%20Asian%20woman%20in%20her%20late%2020s%20in%20a%20stylish%20modern%20apartment%20with%20packed%20boxes%2C%20cheerful%20expression%2C%20bright%20natural%20lighting%2C%20contemporary%20design&width=400&height=500&seq=testimonial105&orientation=portrait',
      highlight: 'LINE 諮詢超方便！'
    },
    {
      id: 6,
      name: '黃先生',
      location: '新北市新莊區',
      service: '廢棄物處理',
      date: '2024年2月',
      rating: 5,
      comment: '廢棄物清運服務很專業，把不要的舊家具都清得乾乾淨淨。師傅們很細心，會先確認哪些要留哪些要丟。價格合理，服務態度也很好，大推！環保處理讓人很安心。',
      image: 'https://readdy.ai/api/search-image?query=Mature%20Asian%20man%20in%20his%2060s%20in%20a%20clean%20organized%20home%20environment%20with%20furniture%2C%20satisfied%20expression%2C%20soft%20warm%20lighting%2C%20tidy%20residential%20background&width=400&height=500&seq=testimonial106&orientation=portrait',
      highlight: '清運服務超讚！'
    }
  ];

  // 自動輪播
  useEffect(() => {
    if (!isAutoPlaying) return;
    
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [isAutoPlaying, testimonials.length]);

  const handlePrev = () => {
    setIsAutoPlaying(false);
    setActiveIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setIsAutoPlaying(false);
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
  };

  const handleDotClick = (index: number) => {
    setIsAutoPlaying(false);
    setActiveIndex(index);
  };

  const getCardStyle = (index: number) => {
    const diff = index - activeIndex;
    const totalCards = testimonials.length;
    
    // 處理循環邏輯
    let adjustedDiff = diff;
    if (diff > totalCards / 2) adjustedDiff = diff - totalCards;
    if (diff < -totalCards / 2) adjustedDiff = diff + totalCards;

    if (adjustedDiff === 0) {
      return {
        transform: 'translateX(0) scale(1)',
        opacity: 1,
        zIndex: 30,
      };
    } else if (adjustedDiff === 1 || adjustedDiff === -totalCards + 1) {
      return {
        transform: 'translateX(80%) scale(0.85)',
        opacity: 0.6,
        zIndex: 20,
      };
    } else if (adjustedDiff === -1 || adjustedDiff === totalCards - 1) {
      return {
        transform: 'translateX(-80%) scale(0.85)',
        opacity: 0.6,
        zIndex: 20,
      };
    } else {
      return {
        transform: 'translateX(0) scale(0.7)',
        opacity: 0,
        zIndex: 10,
      };
    }
  };

  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-amber-50 via-orange-50/30 to-teal-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 標題區域 */}
        <div className="text-center mb-12 md:mb-16">
          {/* 標籤徽章 */}
          <div className="inline-flex items-center gap-2 bg-gray-900 text-white rounded-full px-4 py-2 mb-6">
            <i className="ri-star-fill text-amber-400"></i>
            <span className="text-sm font-medium">客戶真實案例</span>
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            <span className="block">真實客戶</span>
            <span className="block text-teal-600">見證分享</span>
          </h2>
          
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            超過 <strong className="text-teal-600">5000+</strong> 位客戶的信賴，聽聽他們怎麼說
          </p>
        </div>

        {/* 輪播容器 */}
        <div className="relative max-w-5xl mx-auto">
          {/* 卡片容器 */}
          <div className="relative h-[500px] md:h-[420px] flex items-center justify-center">
            {testimonials.map((testimonial, index) => (
              <div
                key={testimonial.id}
                className="absolute w-full max-w-4xl transition-all duration-500 ease-in-out"
                style={getCardStyle(index)}
              >
                <div className="bg-white rounded-3xl shadow-2xl overflow-hidden mx-4">
                  <div className="flex flex-col md:flex-row">
                    {/* 左側照片區域 */}
                    <div className="md:w-2/5 h-64 md:h-auto relative">
                      <img
                        src={testimonial.image}
                        alt={`${testimonial.name} - ${testimonial.service}`}
                        className="w-full h-full object-cover object-top"
                        loading="lazy"
                      />
                      {/* 漸層遮罩 */}
                      <div className="absolute inset-0 bg-gradient-to-t md:bg-gradient-to-r from-black/20 to-transparent"></div>
                      
                      {/* 亮點標籤 */}
                      <div className="absolute bottom-4 left-4 md:bottom-auto md:top-4 bg-gradient-to-r from-amber-500 to-orange-500 text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg">
                        <i className="ri-double-quotes-l mr-1"></i>
                        {testimonial.highlight}
                      </div>
                    </div>

                    {/* 右側內容區域 */}
                    <div className="md:w-3/5 p-6 md:p-10 flex flex-col justify-center">
                      {/* 評分 */}
                      <div className="flex items-center gap-3 mb-4">
                        <div className="bg-amber-100 px-4 py-2 rounded-lg flex items-center gap-2">
                          <div className="flex gap-0.5">
                            {[...Array(testimonial.rating)].map((_, i) => (
                              <i key={i} className="ri-star-fill text-amber-500"></i>
                            ))}
                          </div>
                          <span className="font-bold text-gray-900">{testimonial.rating}.0</span>
                        </div>
                        <span className="text-sm text-gray-500">{testimonial.date}</span>
                      </div>

                      {/* 評論內容 */}
                      <blockquote className="text-gray-700 text-base md:text-lg leading-relaxed mb-6 relative">
                        <i className="ri-double-quotes-l text-4xl text-teal-200 absolute -top-2 -left-2 opacity-50"></i>
                        <p className="relative z-10 pl-4">
                          {testimonial.comment}
                        </p>
                      </blockquote>

                      {/* 客戶資訊 */}
                      <div className="flex items-center gap-4 pt-4 border-t border-gray-100">
                        <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-full flex items-center justify-center text-white text-xl font-bold shadow-lg">
                          {testimonial.name.charAt(0)}
                        </div>
                        <div>
                          <h3 className="font-bold text-gray-900 text-lg">{testimonial.name}</h3>
                          <p className="text-gray-500 text-sm flex items-center gap-1">
                            <i className="ri-map-pin-line text-teal-600"></i>
                            {testimonial.location}
                          </p>
                        </div>
                        <div className="ml-auto">
                          <span className="bg-teal-50 text-teal-700 px-3 py-1.5 rounded-full text-sm font-medium">
                            {testimonial.service}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* 左右切換按鈕 */}
          <button
            onClick={handlePrev}
            className="absolute left-0 md:-left-6 top-1/2 -translate-y-1/2 w-12 h-12 md:w-14 md:h-14 bg-white border-2 border-gray-200 rounded-xl shadow-lg flex items-center justify-center hover:border-teal-500 hover:bg-teal-50 transition-all z-40 cursor-pointer hover:scale-110"
            aria-label="上一則推薦"
          >
            <i className="ri-arrow-left-s-line text-2xl text-gray-700"></i>
          </button>
          <button
            onClick={handleNext}
            className="absolute right-0 md:-right-6 top-1/2 -translate-y-1/2 w-12 h-12 md:w-14 md:h-14 bg-gray-900 rounded-xl shadow-lg flex items-center justify-center hover:bg-teal-600 transition-all z-40 cursor-pointer hover:scale-110"
            aria-label="下一則推薦"
          >
            <i className="ri-arrow-right-s-line text-2xl text-white"></i>
          </button>
        </div>

        {/* 導航點 */}
        <div className="flex justify-center gap-2 mt-8">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => handleDotClick(index)}
              className={`h-2.5 rounded-full transition-all duration-300 cursor-pointer ${
                activeIndex === index
                  ? 'bg-teal-600 w-8'
                  : 'bg-gray-300 w-2.5 hover:bg-gray-400'
              }`}
              aria-label={`查看第 ${index + 1} 則推薦`}
            />
          ))}
        </div>

        {/* 底部統計與 CTA */}
        <div className="mt-12 md:mt-16">
          {/* 統計數據 */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-3xl mx-auto mb-10">
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-4 text-center shadow-md">
              <div className="text-2xl md:text-3xl font-bold text-teal-600 mb-1">5000+</div>
              <div className="text-sm text-gray-600">成功案例</div>
            </div>
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-4 text-center shadow-md">
              <div className="text-2xl md:text-3xl font-bold text-teal-600 mb-1">4.9</div>
              <div className="text-sm text-gray-600">平均評分</div>
            </div>
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-4 text-center shadow-md">
              <div className="text-2xl md:text-3xl font-bold text-teal-600 mb-1">98%</div>
              <div className="text-sm text-gray-600">滿意度</div>
            </div>
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-4 text-center shadow-md">
              <div className="text-2xl md:text-3xl font-bold text-teal-600 mb-1">100%</div>
              <div className="text-sm text-gray-600">推薦率</div>
            </div>
          </div>

          {/* CTA 按鈕 */}
          <div className="text-center">
            <a
              href="https://line.me/ti/p/@285yavdh"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-gradient-to-r from-green-500 to-emerald-500 text-white px-8 py-4 rounded-full text-lg font-bold hover:from-green-600 hover:to-emerald-600 transition-all cursor-pointer shadow-xl hover:shadow-green-500/30 hover:scale-105"
            >
              <img 
                src="https://static.readdy.ai/image/9ef47c451bf9aafd7a63eea67af7d95d/c33a3c3f2fa31df7dfad05bfabc09369.webp" 
                alt="LINE" 
                className="w-6 h-6"
              />
              <span>成為下一個滿意客戶</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </a>
            <p className="text-gray-500 text-sm mt-4">
              立即 LINE 諮詢，獲得專屬搬家方案
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialCarouselSection;
